import React, { useState, useEffect } from 'react';
import BackButton from '../_Shared/BackButton';
import { Form, Col, InputGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { numberValidation, monthValidation } from '../_Shared/Validation';
import result from '../_Shared/Result';
import formulaDefinition from '../_Shared/FormulaDefinition';

function Receivables30() {
    const [receivables, setReceivables] = useState(0);
    const [totalReceivables, setTotalReceivables] = useState(0);
    const [total, setTotal] = useState(0);
    const history = useHistory();

    useEffect(() => {
        setTotal((parseInt(receivables) / parseInt(totalReceivables)) * 100);
    }, [receivables, totalReceivables])

    function clickResult() {
        history.push(
            {
                pathname: `/receivables30result?total=${parseFloat(total).toFixed(2)}`
            })
    }

    const validationSchema = Yup.object({
        receivables: numberValidation,
        totalReceivables: numberValidation
    });

    const def = <span>SPB Receivable Current 0-30 Days &#247; Total SPB Receivables</span>;

    return (
        <Formik
            initialValues={{ receivables: "", totalReceivables: "" }}
            validationSchema={validationSchema}
            onSubmit={e => {
                clickResult();
            }}
        >
            {({ handleSubmit, handleChange, values, errors }) => (

                <div className="container">
                    <main role="main">
                        <div className="jumbotron ">
                            <div className="col-sm-10 mx-auto">
                                <BackButton />
                                <h2 className="text-center">Service and Parts Receivables 0-30 Days</h2>

                                {formulaDefinition(def)}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} md="12" mb="3" controlId="receivables">
                                            <Form.Label>Service, Parts and Body Receivables 0-30 Days</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend> <InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                                <Form.Control size="lg" type="number" name="receivables" value={values.receivables} isInvalid={!!errors.receivables}
                                                onChange={e => { handleChange(e); setReceivables(e.target.value) }} />
                                                <Form.Control.Feedback type="invalid">{errors.receivables}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="totalReceivables">
                                                <Form.Label>Total Service, Parts and Body Receivables</Form.Label>
                                                <InputGroup className="mb-2"><InputGroup.Prepend> <InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                            <Form.Control size="lg" type="number" name="totalReceivables" value={values.totalReceivables} isInvalid={!!errors.totalReceivables}
                                                onChange={e => { handleChange(e); setTotalReceivables(e.target.value) }} />
                                                <Form.Control.Feedback type="invalid">{errors.totalReceivables}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>


                                    </Form.Row>
                                    <p className="pb-5">
                                        <button className="btn btn-primary btn-lg btn-block" type="submit">Calculate &raquo;</button>
                                    </p>
                                </Form>
                            </div>
                        </div>
                    </main>
                </div>
            )}
        </Formik>
    );

}

function Receivables30Result() {
    const urlParams = new URLSearchParams(window.location.search);
    const title = "Service and Parts Receivables 0-30 Days";
    const total = urlParams.get('total') + '%';
    const ratio = "90%";

    const cond = parseFloat(total) >= 90;

    return (
        <div>
            {result(title, total, ratio, cond)}
        </div>
    );
}

export {
    Receivables30,
    Receivables30Result
}